import React, { MouseEventHandler } from 'react';
import theme from './CheckboxTableCell.module.scss';
import { classnames } from '@/utils/html';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

type CheckboxTableCellProps = React.InputHTMLAttributes<HTMLInputElement> & {
    cellClassName?: string;
    onMouseEnter?: MouseEventHandler<HTMLTableCellElement>;
    onMouseLeave?: MouseEventHandler<HTMLTableCellElement>;
    checkboxClassName?: string;
    icon?: IconProp;
};

const CheckboxTableCell: React.FC<CheckboxTableCellProps> = ({
    children,
    icon = faCheck as any,
    cellClassName,
    checkboxClassName,
    onMouseEnter,
    onMouseLeave,
    ...rest
}) => {
    return (
        <td className={classnames(theme.cell, cellClassName)} {...{ onMouseEnter, onMouseLeave }}>
            <label className={theme.label}>
                <input type="checkbox" {...rest} />
                <div className={checkboxClassName}>
                    <div className={theme.icon}>
                        <FontAwesomeIcon icon={icon} />
                    </div>
                </div>
            </label>
        </td>
    );
};

export default CheckboxTableCell;